import React from "react";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import Navbar from "../components/Navbar";
import Banner from "../components/img/Banner/About.png";
import Footer from "../components/common-components/Footer";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";

import Vector1 from "../components/img/Vector1.png";
import Vector2 from "../components/img/Vector2.png";
import Vector3 from "../components/img/Vector3.png";
import Vector4 from "../components/img/Vector4.png";
import ab1 from "../components/img/icon/AddBenifit1.png";
import ab2 from "../components/img/icon/AddBenifit2.png";
import ab3 from "../components/img/icon/AddBenifit3.png";

import icon1 from "../components/img/icon/Learningmode1.png";
import icon2 from "../components/img/icon/Learningmode2.png";
import icon3 from "../components/img/icon/Learningmode3.png";
import icon4 from "../components/img/icon/Learningmode4.png";
import li_icon from "../components/img/icon/li_icon.png";
import DirectorMessage from "../components/home-compo/DirectorMessage";

import lang from "../components/img/Lang.png";
import English from "../components/img/English.png";
import Classroom from "../components/home-compo/Classroom";
import "../styles/pages-style/Home.css";
import "../styles/pages-style/About.css";
import "../styles/pages-style/Mob-view-Home.css";
import Whatsapp from "../components/common-components/Whatsapp.jsx";

function About() {
  const InfoBox = ({ title, description, path }) => (
    <Box className="info-box"
      // sx={{
      //   display: "flex",
      //   height: "100px",
      //   width: "330px",
      //   boxShadow:
      //     "4px 4px 10px rgba(0, 0, 0, 0.2), 0 4px 5px rgba(0, 0, 0, 0.2)",
      // }}
    >
      <Box className="info-box-icon"
        // sx={{
        //   display: "flex",
        //   width: "54px",
        //   height: "100px",
        //   background: "#FFCC25",
        //   alignItems: "center",
        //   justifyContent: "center",
        // }}
      >
        <img
          src={path}
          alt=""
          style={{ width: { sm: 20, md: 24.7 }, height: 27.64 }}
        />
      </Box>
      <Box sx={{ textAlign: "justify", width: "250px", height: "96px" }}>
        <Typography className="info-box-title"
          // sx={{
          //   width: "auto",
          //   height: "20px",
          //   gap: "10px",
          //   color: "#844CEA",
          //   p: "10px",
          //   fontWeight: "600",
          //   fontSize: "16px",
          // }}
        >
          {title}
        </Typography>
        <Typography className="info-box-description"
          // sx={{
          //   width: "230px",
          //   height: "36px",
          //   gap: "10px",
          //   color: "#000000",
          //   p: "10px",
          //   fontWeight: "400",
          //   fontSize: "14px",
          // }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );

  const CourseStructureCard = ({ icon, description }) => (
    <Box
      className="add-benefits"
      sx={{
        display: "flex",
        width: { md: "auto", xs: "auto" },
        height: "70px",
        gap: "10px",
        borderRadius: "12px",
        alignContent: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Box
        className="add-benefits-mt"
        sx={{
          display: "flex",
          flexDirection: "row", // Keeps row layout for both mobile & desktop
          justifyContent: { xs: "center", md: "flex-start" }, // Centers on mobile, left-aligns on desktop
          alignItems: "center",
          width: "100%", // Ensures full width for proper spacing
          mt: { xs: 2, md: 0 }, // Adds margin only on mobile
        }}
      >
        {/* Image Box */}
        <Box
          sx={{
            width: "70px",
            height: "70px",
            borderRadius: "12px",
            background: "#FFCC25",
            alignContent: "center",
            boxShadow: "0px 6px 12px rgba(2, 2, 2, 0.2)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0, // Prevents resizing issues
          }}
        >
          <img src={icon} alt="." />
        </Box>

        {/* Description Box (Now properly aligned) */}
        <Typography
          sx={{
            flexGrow: 1, // Ensures text takes remaining space
            textAlign: "start", // Keeps text aligned properly
            fontSize: { xs: "14px", md: "16px" }, // Responsive font size
            paddingLeft: "12px", // Adds spacing between image & text
            maxWidth: "500px", // Ensures text doesn't stretch too wide
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );

  const learningModes = [
    {
      icon: (
        <img src={icon1} alt="Regular Classes" width="38px" height={"38px"} />
      ),
      title: "Regular Classes",
      desc: "Scheduled Sessions For Complete Syllabus Coverage.",
    },
    {
      icon: (
        <img src={icon2} alt="Regular Classes" width="46px" height={"42px"} />
      ),
      title: "Doubt-Solving Sessions",
      desc: "Dedicated Hours To Clarify Concepts.",
    },
    {
      icon: (
        <img src={icon3} alt="Regular Classes" width="51px" height={"47px"} />
      ),
      title: "Crash Courses",
      desc: "Quick Revisions Before Exams.",
    },
    {
      icon: (
        <img src={icon4} alt="Regular Classes" width="46px" height={"46px"} />
      ),
      title: "Workshops",
      desc: "Skill Building Session For A Specific Topic Like Essay Writing, Map Work & More.",
    },
  ];

  const InfoCard = ({ title, points, width, height }) => (
    <Box
      sx={{
        p: 3,
        mb: 0,
        border: "1px solid #000000",
        borderRadius: "24px",
        textAlign: "center",
        maxWidth: "300px",
        display: "flex",
        flexDirection: "column",
        width: { width },
        height: { height },
        gap: "24px",
        boxShadow: "0px 0px 10px 5px rgba(132, 76, 234, 0.2)",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "#844CEA",
          fontWeight: "bold",
          mb: 1,
        }}
      >
        {title}
      </Typography>
      {/* Add the purple line below the title */}
      <Box
        sx={{
          width: "100%",
          height: "2px",
          display: "flex",
          flexdirection: "column",
          backgroundColor: "#844CEA",
          margin: "0 auto",
          mb: 2,
        }}
      />
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          margin: 0,
          gap: "10px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {points.map((point, index) => (
          <li
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <img
              src={li_icon}
              alt="icon"
              style={{ width: "10px", height: "10px", marginRight: "5px" }}
            />
            <Typography
              variant="body2"
              sx={{
                fontWeight: "500",
                fontSize: "16px",
                color: "#000000",
                lineHeight: "20px",
                textAlign: "start",
              }}
            >
              {point}
            </Typography>
          </li>
        ))}
      </ul>
    </Box>
  );
  const cardData = [
    {
      title: "Why Choose Us?",
      height: "331px",
      width: "417px",
      points: [
        "Interactive Sessions: Fun and engaging activities to keep your child motivated.",
        "Personalized Feedback: Tailored advice to help each student improve. ",
        "Practical Skills: Real-world applications of writing to build confidence and independence. ",
      ],
    },
  ];

  const courses = [
    {
      imgSrc: English,
      title: "English",
      points: [
        "Literature And Grammar Mastery With A Focus On CBSE/ICSE Syllabi.",
        "Creative Writing, Comprehension, And Vocabulary Building.",
        "Spoken English And Communication Skill Enhancement.",
      ],
    },
    {
      imgSrc: lang,
      title: "Languages",
      points: [
        "Guidance For Second And Third Languages, Including Hindi.",
        "Grammar, Writing, And Speaking Practice Tailored To Individual Needs.",
      ],
    },
  ];

  const CourseCard = ({ imgSrc, title, points }) => {
    return (
      <Box
        sx={{
          borderRadius: "5px",
          width: { xs: "auto", sm: "340px" }, // Full width on mobile, fixed on larger screens
          maxWidth: "340px",
          height: "330px", // Allows content to resize properly
          border: "1px solid black",
          backgroundColor: "#fff",
          margin: "0 auto", // Ensures centering on mobile
          display: "flex",
          flexDirection: "column", // Stacks elements vertically
          alignItems: "center", // Centers content
          padding: { xs: "15px", sm: "10px" }, // Adds spacing on mobile
        }}
      >
        {/* Image & Title Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "100%", // Adapts to container width
            justifyContent: "center",
            gap: "10px", // Ensures proper spacing between image & text
            flexWrap: "nowrap",
          }}
        >
          <Box
            sx={{
              height: "50px", // Scaled down for mobile
              width: "50px",
              minWidth: "50px",
              borderRadius: "50%",
              border: "1px solid black",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              background: "#FFFFFF",
            }}
          >
            <img
              src={imgSrc}
              alt={title}
              style={{ height: "30px", width: "30px" }} // Adjusted for mobile view
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "auto",
              width: "100%", // Adapts to text width
              maxWidth: "250px", // Prevents text overflow
              background: "#FFD700",
              borderRadius: "8px",
              padding: "8px",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "600",
                fontFamily: "'Kumbh Sans', sans-serif",
                textAlign: "center",
                fontSize: { xs: "14px", sm: "16px" }, // Adjusted for mobile
              }}
            >
              {title}
            </Typography>
          </Box>
        </Box>

        {/* Content List */}
        <Box
          component="ul"
          sx={{
            mt: 2,
            padding: "10px",
            width: "100%", // Adapts to container
            maxWidth: "320px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            gap: "8px",
          }}
        >
          {points.map((point, index) => (
            <Box
              key={index}
              component="li"
              sx={{
                display: "flex",
                alignItems: "flex-start",
                mb: 1,
                fontSize: "1rem",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  color: "#844CEA",
                  fontWeight: "bold",
                  mr: 1,
                  fontFamily: "'Kumbh Sans', sans-serif",
                }}
              >
                •
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "14px", sm: "16px" },
                  lineHeight: "20px",
                  fontWeight: "400",
                  fontFamily: "'Quicksand', sans-serif",
                  textAlign: "justify",
                }}
              >
                {point}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };
  const testimonialsRef = useRef(null);

  const scrollToTestimonials = () => {
    if (testimonialsRef.current) {
      testimonialsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const navigate = useNavigate();

  const enrollClick = () => {
    navigate("/ContactUs");
  };

  return (
    <Box className="root-container" sx={{ overflowX: "hidden" }}>
      <Navbar scrollToTestimonials={scrollToTestimonials} />
      <Whatsapp />
      <Box className="global-container">
        {/* image */}

        <Box
          sx={{
            width: { xs: "95vw", sm: "90vw", md: "80vw", lg: "94vw" }, // Responsive width
            height: { xs: "140px", sm: "320px", md: "444px" }, // Auto height for mobile, fixed for desktop
            mt: { xs: "12vh", md: "16vh" }, // Adjust margin only for mobile
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <img
            src={Banner}
            alt="About"
            style={{
              width: "100%", // Responsive width
              height: "auto", // Maintains aspect ratio
              objectFit: "contain", // Ensures no cropping
              maxWidth: "100%", // Full width for desktop
              maxHeight: "none", // No limit on desktop
              borderRadius: "12px",
            }}
          />

          <Box
            sx={{
              position: "absolute",
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              alignItems: "center",
              padding: "5px 10px",
              borderRadius: "5px",
              textAlign: "center", // Ensures text stays centered
              width: "100%", // Ensure it adjusts correctly
            }}
          >
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: { xs: "20px", sm: "24px", md: "28px" }, // Responsive font sizes
                color: "#FFFFFF",
                fontFamily: "'Kumbh Sans', sans-serif",
              }}
            >
              About Us
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "600",
                  fontSize: { xs: "16px", sm: "18px", md: "20px" }, // Responsive text
                  color: "#FFFFFF",
                  fontFamily: "'Kumbh Sans', sans-serif",
                  pr: "5px",
                }}
              >
                Home
              </Typography>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: { xs: "16px", sm: "18px", md: "20px" },
                  color: "#FFCC25",
                  fontFamily: "'Kumbh Sans', sans-serif",
                }}
              >
                {" "}
                / About
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* why chose us  */}

        <Box
          sx={{
            mt: "5vh",
            width: { xs: "90%", md: "87%" }, // 90% width on mobile to prevent stretching out
            maxWidth: { xs: "600px", md: "none" }, // Prevents going too wide on small screens
            height: "auto", // Allow dynamic height
            textAlign: "justify",
            p: 4,
            background: "#FFFFFF",
            borderRadius: "10px",
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" }, // Single column on mobile, two columns on desktop
            gridTemplateRows: "auto",
            justifyContent: "center",
            alignItems: "center",
            gap: { xs: "20px", md: "40px" }, // Adjust gap for better spacing
            margin: "0 auto", // Centers the box properly
            px: { xs: 2, md: 4 }, // Adds padding to prevent content touching edges on mobile
          }}
        >
          {/* welcome-text */}

          <Box
            sx={{
              height: "auto", // Allows dynamic height
              width: "100%", // Adjusts to screen size
              // maxWidth: "574px", // Prevents exceeding this width
              // gap: "px",
              mt: { mt: "5vh" },
              justifyContent: "center", // Keeps text centered on small screens
            }}
          >
            <Box
              sx={{
                width: "auto",
                textAlign: "left", // Ensures left alignment
                ml: { xs: "3%", md: 0 }, // Moves slightly to the left on mobile, no change for desktop
                // px: { xs: 1, sm: 4 }, // Adds padding for spacing
                mb: { xs: 0, md: 8 },
              }}
            >
              {" "}
              {/* <Typography
                sx={{
                  fontSize: { xs: "20px", sm: "24px", md: "30px" }, // Responsive font sizes
                  fontWeight: "600",
                  fontFamily: "Kumbh Sans, sans-serif !important;",
                  // marginLeft: "0px",
                  marginRight: "auto",
                  // Prevents text wrapping
                }}
              >
                Welcome To 
              </Typography>
              <Typography
                component="span" // Keeps it inline
                sx={{
                  color: "#FFCC25",
                  fontSize: { xs: "24px", sm: "26px", md: "28px", lg: "30px" },
                  fontWeight: "600",
                  fontFamily: "Kumbh Sans, sans-serif !important;",
                }}
              >
                Hrishi’s Holistic Hub
              </Typography> */}
              <Typography className="welcome-text">Welcome To</Typography>
            <Typography className="welcome-text yellow-text">
              {" "}
              Hrishi’s Holistic Hub
            </Typography>
            </Box>

            {/* paragraphs */}

            <Box
              sx={{
                height: "auto", // Allows dynamic height
                width: { xs: "auto", sm: "95%", md: "574px" }, // Adjusts width for different screens
                maxWidth: { md: "574px" }, // Ensures it does not exceed this width on desktop
                padding: "6px",
                gap: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center", // Keeps content centered on all screen sizes
              }}
            >
              <Typography
                sx={{
                  mt: "18px",
                  fontSize: { xs: "14px", lg: "16px" },
                  fontWeight: "500",
                  fontFamily: "Kumbh Sans, sans-serif !important;",
                  color: "#616161",
                  lineHeight: { xs: "18px", md: "20px" }, // Better spacing for mobile
                  textAlign: { xs: "justify", md: "left" }, // Justify on mobile, keep normal on desktop
                  px: { xs: 2, md: 0 }, // Adds padding on mobile to avoid edge-clipping
                  maxWidth: { xs: "90%", md: "none" }, // Restricts width on mobile for proper word spacing
                  margin: { xs: "0 auto", md: "0" }, // Centers text block on mobile
                }}
              >
                Building Bridges to Confidence and Success  At Hrishi’s Holistic
                Hub, we are dedicated to empowering students to excel not only
                in academics but also in life. Our innovative approach bridges
                the gap between knowledge and application, helping students
                build the confidence they need to tackle challenges and achieve
                their dreams. With personalized guidance, expert educators, and
                a focus on holistic development, we pave the way for success—one
                step at a time. Join us on this journey of growth, where every
                student discovers their true potential!   {" "}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "14px", lg: "16px" },
                  fontWeight: "500",
                  fontFamily: "Kumbh Sans, sans-serif !important;",
                  color: "#616161",
                  lineHeight: { xs: "18px", md: "20px" }, // Improved spacing for mobile
                  mt: { xs: 4, md: 12 },
                  textAlign: { xs: "justify", md: "left" }, // Justifies text only on mobile
                  px: { xs: 2, md: 0 }, // Adds padding on mobile to prevent edge-clipping
                  maxWidth: { xs: "90%", md: "none" }, // Ensures proper width for word spacing
                  margin: { xs: "0 auto", md: "0" }, // Centers text on mobile for better readability
                }}
              >
                Where learning meets growth and empowerment! Founded with a
                vision to provide more than just academic excellence, Hrishi’s
                Holistic Hub is a nurturing space where students thrive
                academically, emotionally, and socially. We believe that every
                child has the potential to excel when given the right guidance,
                tools, and encouragement.  Our mission is to foster a love for
                learning while developing the skills and confidence students
                need to succeed in today’s world. At Hrishi’s Holistic Hub, we
                combine personalized teaching with innovative techniques to
                ensure each student reaches their full potential.  Join us at
                Hrishi’s Holistic Hub, where education is more than grades—it’s
                about building a foundation for lifelong success. Let’s grow
                together!
              </Typography>
            </Box>
          </Box>

          {/* why choose card */}

          <Box
            sx={{
              margin: "0 auto", // Centers the box horizontally
              // maxWidth: { xs: "90%", sm: "80%", md: "42vw" }, // Prevents excessive width on mobile
            }}
          >
            <Box
              sx={{
                height: "auto",
              }}
            >
              <Typography
                className="section-title"
                // sx={{
                //   fontWeight: "700",
                //   fontSize: { xs: "24px", md: "28px" },
                //   fontFamily: "Kumbh Sans",
                //   mt: { xs: 0, md: 8 },
                // }}
              >
                Why Choose Our Program?
              </Typography>
              <Box
                className="info-box-grid"
                // sx={{
                //   mt: "4vh",
                //   background: "#FFFFFF",
                //   display: "grid",
                //   gridTemplateColumns: {
                //     xs: "1fr",
                //     sm: "repeat(2, 1fr)",
                //     md: "repeat(2, 1fr)",
                //   }, // 1 column on small screens, 2 on larger
                //   gridTemplateRows: "auto", // Allows flexible row adjustment
                //   gap: "20px",
                //   alignItems: "center",
                //   justifyContent: "center",
                //   padding: { xs: "12px", sm: "4px" }, // Adds padding for spacing
                // }}
              >
                <InfoBox
                  title="Experienced Faculty"
                  description="Teachers with expertise in subject-specific teaching."
                  path={Vector1}
                />
                <InfoBox
                  title="Individual Attention"
                  description="Small group sizes to address every student's needs."
                  path={Vector2}
                />
                <InfoBox
                  title="Comprehensive Resources"
                  description="Access to notes, worksheets, and video tutorials."
                  path={Vector3}
                />
                <InfoBox
                  title="Exam- ready Preparation"
                  description="Emphasis on board and competitive exam success."
                  path={Vector4}
                />
              </Box>
            </Box>

            {/* additional benefit */}

            <Box
              sx={{
                height: "auto",
                width: "auto",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                marginLeft: { xs: 0, sm: "4%", md: 0 },
              }}
            >
              <Typography
                sx={{
                  width: "auto",
                  padding: "10px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: {
                    xs: "flex-start",
                    sm: "center",
                    md: "flex-start",
                  },
                  alignContent: "center",
                  gap: "10px",
                  height: "31px",
                  fontSize: { xs: "24px", lg: "25px" },
                  fontWeight: "700",
                  fontFamily: "Kumbh Sans, sans-serif !important;",
                  mt: { xs: 0, sm: 6, md: 2 },
                }}
              >
                Additional Benefits
              </Typography>
              <CourseStructureCard
                icon={ab1}
                description="Access to an exclusive library of resources, including worksheets, videos, and e-books. "
              />
              <CourseStructureCard
                icon={ab2}
                description="Periodic assessments to track and boost progress. "
              />
              <CourseStructureCard
                icon={ab3}
                description="Certificates of completion to celebrate achievements. "
              />
            </Box>
          </Box>
        </Box>

        {/* learning models section  */}

        <Box sx={{ textAlign: "center", p: { xs: 2, md: 5 } }}>
          {/* Section Title */}
          <Typography sx={{ fontSize: "24px", fontWeight: 700 }} gutterBottom>
            Our Learning Modes
          </Typography>

          {/* Cards Container */}
          <Box
            sx={{
              width: { xs: "auto", md: "1321px" }, // Full width on mobile, fixed on desktop
              height: "auto", // Adjust height dynamically
              gap: "16px",
              mt: "5vh",
              display: "flex",
              flexDirection: { xs: "column", md: "row" }, // Column layout on mobile, row on desktop
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {learningModes.map((mode, index) => (
              <Card
                key={index}
                sx={{
                  width: { xs: "90%", sm: "318px" }, // Responsive width
                  height: { xs: "90%", sm: "234px" }, // Allow dynamic height
                  gap: "6px",
                  px: "24px",
                  py: "12px",
                  border: "1px solid #844CEA",
                  boxShadow: "6px 6px 14px rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
              >
                <CardContent
                  sx={{
                    textAlign: "start",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    p: 2,
                  }}
                >
                  <Box sx={{ color: "#673AB7", mb: 1 }}>{mode.icon}</Box>
                  <Box
                    sx={{
                      width: "100%", // Full width for better responsiveness
                      padding: "10px",
                    }}
                  >
                    <Typography
                      fontWeight="600"
                      fontSize="18px"
                      fontFamily="'kumbh sans','sans-serif'"
                      color="#844CEA"
                    >
                      {mode.title}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%", // Full width for better alignment
                      padding: "10px",
                    }}
                  >
                    <Typography
                      fontWeight="500"
                      fontSize="14px"
                      fontFamily="'Quicksand', sans-serif"
                      color="#000000"
                    >
                      {mode.desc}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Box>

        {/* Info Cards Section */}
        {cardData.map((data, index) => (
          <Box
            key={index}
            sx={{
              mt: "5vh",
              display: "flex",
              justifyContent: "center",
              width: "auto", // Ensures it adapts to screen width
              padding: "2%",
            }}
          >
            <InfoCard
              title={data.title}
              points={data.points}
              height={data.height}
              width={{ xs: "90%", sm: data.width }} // Responsive width
            />
          </Box>
        ))}

        <Typography
          marginTop={3}
          lineHeight={{ xs: "22px", md: "20px" }} // Increases line height on small screens for readability
          fontWeight={500}
          fontSize={{ xs: "14px", sm: "15px", md: "16px" }} // Adjusts font size based on screen size
          width={{ xs: "90%", sm: "80%", md: "1226px" }} // Responsive width
          height="auto" // Allows dynamic height so text wraps naturally
          textAlign="center"
          fontFamily="Kumbh Sans, sans-serif !important;"
        >
          Let’s turn young learners into artists of their own stories. With a
          pen in their hand, they’ll be ready to create magic on paper. Writing
          will no longer feel like a task but a joyful expression of their
          thoughts and imagination.
        </Typography>

        <Box sx={{ mt: "8vh" }}></Box>

        {/* Director */}

        <Box className="director-message-container">
          <DirectorMessage />
        </Box>

        {/* Popular Course */}

        <Typography
          sx={{
            // width: "60vw",
            // height: "37px",
            fontWeight: "700",
            fontSize: "24px",
            textAlign: "center",
            color: "#000000",
            py: "3vh",
            fontFamily: "Kumbh Sans, sans-serif !important;",
          }}
        >
          Our Popular Courses
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 5,

            height: "auto",
            justifyContent: { xs: "center", sm: "center", md: "flex-start" }, // Center align on mobile, default on desktop
            flexDirection: { xs: "column", sm: "row" }, // Column layout on mobile, row on desktop
            mx: { xs: "auto", md: 0 }, // Centers the box on mobile
            px: { xs: 2, md: 0 }, // Adds padding on mobile to avoid edge contact
            mt: { xs: 5, md: 0 },
          }}
        >
          {courses.map((course, index) => (
            <Box key={index}>
              <CourseCard
                imgSrc={course.imgSrc}
                title={course.title}
                points={course.points}
              />
            </Box>
          ))}
        </Box>

        <Box sx={{ height: "6vh" }}></Box>

        {/* purpleenroll */}

        <Box className="fifth-section">
          <Box className="fifth-section-text">
            <Typography variant="h6">
              Enroll today and watch your child’s creativity soar!
            </Typography>
          </Box>
          <Button
            variant="contained"
            className="fifth-section-button"
            onClick={() => {
              enrollClick();
              window.scrollTo({ top: 0 });
            }}
          >
            Enroll Now
          </Button>
        </Box>

        {/* classroom  */}

        <Box sx={{ height: "6vh" }}></Box>
        <Box className="ninth-section-container">
          <Classroom />
        </Box>
        <Box sx={{ height: "10vh" }}></Box>
      </Box>

      {/* footer */}

      <Box className="footer-class" sx={{ width: "98.3%" }}>
        <Footer scrollToTestimonials={scrollToTestimonials} />
      </Box>
    </Box>
  );
}

export default About;
